import {hostName} from "../endpoint";
import {defaultHeaders} from "../headers";

export const resetBusinessPassword = async (password, token) => {
  try {
    const result = await fetch(`${hostName}/business/update-password`, {
      method: "POST",
      headers: defaultHeaders,
      body: JSON.stringify({password, token}),
    });
    const response = await result.json();
    return response.isSuccessful;
  } catch (err) {
    return false;
  }
};
